import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';
import { Observable, catchError, throwError, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KanbanCustomizadoService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  // Notifica quem exibe o menu dinâmico do Kanban (sidebar) após criar/editar/excluir um Kanban em kanban-config
  private kanbanAlterado = new Subject<void>();
  kanbanAlterado$ = this.kanbanAlterado.asObservable();

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  notificarAlteracao(): void {
    this.kanbanAlterado.next();
  }

  meus(): Observable<any> {
    this.httpOptions.params = null;
    return this.http.get(`${this.apiUrl}api/kanban-customizado/meus`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  board(kanban_customizado_id: number, params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/kanban-customizado/${kanban_customizado_id}/board`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  boardEtapa(kanban_customizado_id: number, etapa_id: number, params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/kanban-customizado/${kanban_customizado_id}/board/etapas/${etapa_id}`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  moverChamado(kanban_customizado_id: number, chamado_id: number, etapa_id: number): Observable<any> {
    this.httpOptions.params = null;
    return this.http.put(`${this.apiUrl}api/kanban-customizado/${kanban_customizado_id}/chamados/${chamado_id}/etapa`, { etapa_id }, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  listar(filtros, config): Observable<any> {
    this.httpOptions.params = config;
    return this.http.post(`${this.apiUrl}api/kanban-customizado/listagem`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  obtem(kanban_customizado_id: number): Observable<any> {
    this.httpOptions.params = null;
    return this.http.get(`${this.apiUrl}api/kanban-customizado/${kanban_customizado_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  criar(payload): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/kanban-customizado`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizar(kanban_customizado_id: number, payload): Observable<any> {
    this.httpOptions.params = null;
    return this.http.put(`${this.apiUrl}api/kanban-customizado/${kanban_customizado_id}`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deletar(kanban_customizado_id: number): Observable<any> {
    this.httpOptions.params = null;
    return this.http.delete(`${this.apiUrl}api/kanban-customizado/${kanban_customizado_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  // PR-F3: verificação/remoção de vínculo de mesas e operadores com a regra de configuração do Kanban (CA17)
  verificarVinculosMesas(ids: number[]): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/kanban-customizado/vinculos/mesas/verificar`, { ids }, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  removerVinculosMesas(ids: number[]): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/kanban-customizado/vinculos/mesas/remover`, { ids }, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  verificarVinculosUsuarios(ids: number[]): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/kanban-customizado/vinculos/usuarios/verificar`, { ids }, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  removerVinculosUsuarios(ids: number[]): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/kanban-customizado/vinculos/usuarios/remover`, { ids }, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    return throwError({ status: error.status, ...error.error });
  }
}
